import type { ConversationSummary } from './conversations';
import type { PersonRef } from './people';

export type Block = { id: string; person: PersonRef | null; createdAt: string };

/** The group conversations I share with the person; blocking may leave them. */
export type BlockPreview = { sharedGroupConversations: ConversationSummary[] };

export type ReportTargetKind = 'comment' | 'listing' | 'person' | 'collection';

export type NewReport = { targetKind: ReportTargetKind; targetId: string; note: string };

export type ReportReceipt = { id: string; createdAt: string };

// ── Copy shared by every safety screen (017 research D21–D24) ─────────────

/** What blocking does, said before the blocker confirms (FR-002). */
export function blockConsequences(firstName: string): string[] {
  return [
    `You and ${firstName} won't be connected.`,
    "Neither of you will be a member of the other's collections.",
    "You won't be able to message each other.",
    "You won't see each other's listings.",
    "In collections and group chats you both stay in, each other's comments and messages will be collapsed.",
    `${firstName} won't be told.`,
  ];
}

/** What a comment or group message reads as while a block stands between us. */
export function collapsedLabel(kind: 'comment' | 'message'): string {
  return kind === 'comment' ? 'Blocked comment' : 'Blocked message';
}

export function reportHeading(kind: ReportTargetKind): string {
  return `Report this ${kind}`;
}

export const REPORT_SENT = 'Report sent. Thanks for letting us know.';

/** The one question before unblocking; it restates that nothing comes back (FR-024). */
export function unblockPrompt(person: PersonRef | null): { title: string; body: string } {
  const name = person ? `${person.firstName} ${person.lastName}`.trim() : null;
  return {
    title: name ? `Unblock ${name}?` : 'Unblock this account?',
    body: "You'll be able to message each other if you share a collection. You won't be reconnected; to connect again, one of you sends a new invite.",
  };
}
